import React, { SyntheticEvent } from 'react';
import {
  ISubFolderFieldsFragment,
  PermissionKey,
} from '../../../../utils/apollo/graphqlSchema';
import { useAppDispatch } from '../../../../redux/hooks';
import { ModalSliceType, openModal } from '../../../../redux/slices/modal';
import ActionsMenu from '../../../../components/ActionsMenu';
import usePermission from '../../../../utils/hooks/permissionHooks/usePermission';
import { SingleSelectOption } from '../../../../components/Dropdown/SingleSelect';
import styled from 'styled-components';
import {
  defaultPermissionTooltipOption,
  cantDeleteNonEmptyFolderTooltipOption,
} from '../../../../components/KubitTooltip/globalTooltips';

interface IProps {
  subFolder: ISubFolderFieldsFragment;
  onOpen?: () => void;
  onClose?: () => void;
  triggerRenameSubFolder?: () => void;
}

const StyledActionsMenu = styled(ActionsMenu)`
  flex: 0 0 auto;
  display: inline-flex;
`;

const SubFolderActions = ({
  subFolder,
  onOpen,
  onClose,
  triggerRenameSubFolder,
}: IProps) => {
  const dispatch = useAppDispatch();
  const { checkIsPermitted } = usePermission();
  const isPermittedToRenameFolder = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.DashboardFolderEdit],
  });
  const isPermittedToDeleteFolder = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.DashboardFolderDelete],
  });

  const handleRename = (event: SyntheticEvent) => {
    event.stopPropagation();
    triggerRenameSubFolder?.();
  };

  const handleDelete = (event: SyntheticEvent) => {
    event.stopPropagation();
    dispatch(
      openModal({
        type: ModalSliceType.DashboardFolderDelete,
        data: subFolder,
      }),
    );
  };

  const subFolderIsEmpty = subFolder.isEmpty;
  const isDeleteDisabled = !isPermittedToDeleteFolder || !subFolderIsEmpty;

  return (
    <StyledActionsMenu
      onClick={(event) => {
        event.stopPropagation();
      }}
      onOpen={onOpen}
      onClose={onClose}
    >
      <SingleSelectOption
        onClick={handleRename}
        iconName="pencil"
        label={'Rename'}
        disabled={!isPermittedToRenameFolder}
        tooltipOption={
          !isPermittedToDeleteFolder
            ? defaultPermissionTooltipOption
            : undefined
        }
      />
      <SingleSelectOption
        onClick={handleDelete}
        iconName="trash"
        label={'Delete'}
        disabled={!isPermittedToDeleteFolder || !subFolder.isEmpty}
        tooltipOption={
          !isPermittedToDeleteFolder
            ? defaultPermissionTooltipOption
            : isDeleteDisabled
              ? cantDeleteNonEmptyFolderTooltipOption
              : undefined
        }
      />
    </StyledActionsMenu>
  );
};

export default SubFolderActions;
